import {BotSpeedSettings, DiceSettingEnum, ExtensionSettingEnum, GameSpeedSettings, MapSettingEnum, ModeSettingEnum, ScenarioSettingEnum} from '@colonist/types'

// maybe this should be in its own package
export class RoomSettingConstants {
    static readonly MIN_VP_TO_WIN = 3
    static readonly DEFAULT_VP_TO_WIN = 10

    static readonly MIN_CARD_DISCARD_LIMIT = 5
    static readonly DEFAULT_CARD_DISCARD_LIMIT = 7
    static readonly MAX_CARD_DISCARD_LIMIT = 20

    static readonly MIN_PLAYER_COUNT = 1
    static readonly DEFAULT_PLAYER_COUNT = 4
    static readonly MAX_PLAYER_COUNT = 8

    static readonly DEFAULT_GAME_SPEED_SETTING = GameSpeedSettings.Base120s
    static readonly DEFAULT_BOT_SPEED_SETTING = BotSpeedSettings.Normal

    static readonly DEFAULT_HIDE_BANK_CARDS = false
    static readonly DEFAULT_FRIENDLY_ROBBER = false

    static readonly DEFAULT_MODE_SETTING = ModeSettingEnum.Classic4P
    static readonly DEFAULT_EXTENSION_SETTING = ExtensionSettingEnum.Players4
    static readonly DEFAULT_SCENARIO_SETTING = ScenarioSettingEnum.None
    static readonly DEFAULT_MAP_SETTING = MapSettingEnum.Classic4P
    static readonly DEFAULT_DICE_SETTING = DiceSettingEnum.Random

    static readonly DEFAULT_KARMA_THRESHOLD = 0
    static readonly NO_TROLLS_KARMA_THRESHOLD = 19
}
